import React, { useState } from 'react'
import { PastureHistoricModal } from '../components/PastureHistoricModal'

export const usePastureHistoricModal = (pastureId?: string) => {
  const [isOpen, setIsOpen] = useState(false)

  const open = () => setIsOpen(true)
  const close = () => setIsOpen(false)

  const PastureHistoricModalComponent = () =>
    isOpen ? <PastureHistoricModal isOpen={true} onClose={close} pastureId={pastureId} /> : null

  return {
    open,
    close,
    isOpen,
    PastureHistoricModal: PastureHistoricModalComponent
  }
}
